/**
 * Detects if the current browser is a FairPlay-capable browser (Safari/iOS)
 * @param {string} [userAgent] - Optional user agent string (defaults to navigator.userAgent)
 * @returns {boolean} True if the browser supports FairPlay DRM
 */
export function isFairPlayBrowser(userAgent = navigator.userAgent) {
  return /iPad|iPhone|iPod/.test(userAgent) ||
    (/Safari/.test(userAgent) && !/Chrome/.test(userAgent));
}

/**
 * Detects if the current browser is running on iOS
 * @param {string} [userAgent] - Optional user agent string (defaults to navigator.userAgent)
 * @returns {boolean} True if running on iOS
 */
export function isIOS(userAgent = navigator.userAgent) {
  return /iPad|iPhone|iPod/.test(userAgent);
}

/**
 * Detects if the current browser is Safari (but not Chrome)
 * @param {string} [userAgent] - Optional user agent string (defaults to navigator.userAgent)
 * @returns {boolean} True if the browser is Safari
 */
export function isSafari(userAgent = navigator.userAgent) {
  return /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
}

/**
 * Detects if the current browser uses the Gecko engine (Firefox, Waterfox, etc.)
 * @param {string} [userAgent] - Optional user agent string (defaults to navigator.userAgent)
 * @returns {boolean} True if the browser is Gecko-based
 */
export function isGecko(userAgent = navigator.userAgent) {
  return /Gecko\//.test(userAgent) && !/like Gecko/.test(userAgent);
}

/**
 * Detects if the current browser is Chrome (or Chromium-based)
 * @param {string} [userAgent] - Optional user agent string (defaults to navigator.userAgent)
 * @returns {boolean} True if the browser is Chrome-based
 */
export function isChrome(userAgent = navigator.userAgent) {
  return /Chrome/.test(userAgent) && !/Edg/.test(userAgent);
}
